export const MARGIN = {
    bottom: 25,
    left: 100,
    top: 10,
    right: 50,
};

export const LINE_KEY = "Cumulative net cash flow";
